import * as _ from 'lodash'
import { Divider, Text } from '@wework/dieter-ui'
import StatusTag, { SpaceStatus } from '../StatusTag'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import React from 'react'
import './styles.css'
import { DATE_FORMAT } from '../../constants/date'
import withConfiguration from '../../hoc/withConfiguration'

function PPWKSection({
  space,
  border = false,
  containerStyle = {},
  borderBottom = false,
  configuration,
}: any) {
  const contract = _.get(space, 'reservable.contract')

  if (!contract) {
    return null
  }

  const { spacestationBaseUrl } = configuration

  const { account, primaryMember } = contract

  // const label = status === 'Sent' ? 'Pending' : 'Expired'

  return (
    <>
      <div
        style={{
          position: 'relative',
          padding: 16,
          borderRadius: '.25rem',
          border: border ? '1px solid #E6E6E6' : 0,
          ...containerStyle,
        }}
      >
        <StatusTag status={SpaceStatus.PENDING} />

        <Text
          size="medium"
          primary
          style={{ marginTop: 12, marginBottom: 2 }}
          href={`${spacestationBaseUrl}companies/${account.uuid}`}
          target="_blank"
          as="a"
        >
          {`${account.name}`}
        </Text>
        <Text size="tiny">{`${primaryMember.name}`}</Text>
        <Text size="tiny" style={{ fontWeight: '600', marginTop: 18 }}>
          Move in/out
        </Text>
        <Text size="tiny">
          {contract.startDate &&
            format(parseISO(contract.startDate), DATE_FORMAT.DATE)}
          –{' '}
          {contract.endDate &&
            format(parseISO(contract.endDate), DATE_FORMAT.DATE)}
        </Text>
      </div>

      {borderBottom && <Divider light style={{ margin: 0 }} />}
    </>
  )
}

export default withConfiguration()(PPWKSection)
